import React from "react";
import "./AlertModal.less";
// 定义 AlertModal 组件的 Props 类型
interface AlertModalProps {
  title: string;
  msg?: string;
  remark?: string;
  buttonTxt?: string;
  onButtonClick: () => void;
  onClose: () => void;
}

const checkIfHaveKeyWord = (
  text?: string,
  keywords: string[] = [],
): boolean => {
  if (!text) {
    return false;
  }
  let foundKeyword = false; // 标记是否找到了关键词
  for (const keyword of keywords) {
    const keywordIndex = text.indexOf(keyword);
    if (keywordIndex !== -1 && !foundKeyword) {
      foundKeyword = true;
      break;
    }
  }

  return foundKeyword;
};
// 辅助函数，用于处理包含特定关键词的文本，高亮第一个找到的关键词及其后面的文字，并加粗关键字
const processTextWithKeywords = (
  text?: string,
  keywords: string[] = [],
  ismoreKeyWord: boolean = false,
): React.ReactNode => {
  if (!text) return <></>; // 如果没有文本，则返回一个空的React节点

  let processedText: React.ReactNode = text; // 初始化处理后的文本为原始文本（作为备选方案）
  let foundKeyword = false; // 标记是否找到了关键词
  let isLg = false;
  isLg = ismoreKeyWord;
  // 遍历关键词数组，找到第一个出现的关键词并进行处理
  for (const keyword of keywords) {
    const keywordIndex = text.indexOf(keyword);
    if (keywordIndex !== -1 && !foundKeyword) {
      // 关键词前面的文本部分
      const beforeKeyword = (
        <span className="normal-text">{text.slice(0, keywordIndex)}</span>
      );
      // 关键词本身（加粗显示）
      const keywordElement = (
        <span className={`bold-text ${isLg ? "isLg" : ""}`}>
          {text.slice(keywordIndex, keywordIndex + keyword.length)}
        </span>
      );
      // 关键词后面的文本部分（高亮显示）
      const afterKeyword = text.slice(keywordIndex + keyword.length);
      const highlightAfterKeyword = (
        <span className="highlight-text">{afterKeyword}</span>
      );

      // 组合处理后的文本并标记已找到关键词
      processedText = (
        <>
          {beforeKeyword}
          {keywordElement}
          {highlightAfterKeyword}
        </>
      );
      foundKeyword = true; // 标记为已找到关键词，以便不再处理其他关键词
      break; // 找到关键词后退出循环
    }
  }

  // 返回处理后的文本（React节点）
  return processedText;
};
const AlertModal: React.FC<AlertModalProps> = ({
  title,
  msg,
  remark,
  buttonTxt = "确定",
  onButtonClick,
  onClose,
}) => {
  // 定义需要高亮的关键词
  const keywords = ["获得", "附赠"];
  const msgKeyWord = checkIfHaveKeyWord(msg, keywords);
  const remarkKeyWord = checkIfHaveKeyWord(remark, keywords);

  // 处理 msg 和 remark 字段
  const msgParts: React.ReactNode = processTextWithKeywords(
    msg,
    keywords,
    remarkKeyWord,
  );
  const remarkParts: React.ReactNode = processTextWithKeywords(
    remark,
    keywords,
    msgKeyWord,
  );

  let showIknow = title.includes("兑换失败");
  return (
    <div className="alert-modal">
      <div className="container">
        <h3>{title}</h3>
        {msg && (
          <p
            className={`${remark == "" || remark == undefined || remark == null ? "singleMSG" : ""} ${msgKeyWord ? "flex" : ""}`}
          >
            {msgParts}
          </p>
        )}
        {remark && (
          <p
            className={`remarkP ${msgKeyWord && remarkKeyWord ? "flex" : ""} ${!msg ? "top40" : ""}`}
          >
            {remarkParts}
          </p>
        )}
      </div>
      <div className="btnRow">
        {!showIknow ? (
          <>
            <span className="iknow" onClick={onClose}>
              我知道了
            </span>
            <span className="operator" onClick={onButtonClick}>
              {buttonTxt}
            </span>
          </>
        ) : (
          <span className="operator single" onClick={onButtonClick}>
            {buttonTxt}
          </span>
        )}
      </div>
    </div>
  );
};

export default AlertModal;
